<template>
  <div class="dialog">
    <el-dialog
      v-if="dialogData.dialogVisible"
      :title="dialogData.title"
      :visible.sync="dialogData.dialogVisible"
      :width="dialogData.width"
      center
      :close-on-click-modal="false"
      top="0"
    >
      <template slot-scope="scope">
        <extend :render="dialogData.render" :params="scope"></extend>
      </template>
      <span v-if="dialogData.buttonNum" slot="footer" class="dialog-footer two">
        <el-button @click="dialogData.dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="closeDialog">确 认</el-button>
      </span>
      <span v-else slot="footer" class="dialog-footer one">
        <el-button
          :disabled="dialogData.isdisabled ? true : false"
          type="primary"
          @click="closeDialog"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import extend from "@/assets/js/renderProps.js";
export default {
  components: { extend },
  data() {
    return {};
  },
  props: {
    dialogData: Object
  },

  methods: {
    closeDialog() {
      this.$emit("close-dialogStatus", false);
    }
  },
  mounted() {}
};
</script>
<style>
.dialog .el-dialog--center {
  min-width: 0 !important;
}
.dialog .el-dialog__wrapper {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}
.dialog .el-dialog__header {
  padding: 0 !important;
  height: 47px !important;
  line-height: 47px !important;
}
.dialog .el-dialog__title {
  font-size: 14px !important;
  color: #333333 !important;
  line-height: 19px !important;
}
.dialog .el-dialog__headerbtn {
  top: 0 !important;
  line-height: 47px !important;
}
.dialog .el-dialog__footer {
  padding: 0 !important;
}
.dialog .el-dialog__body {
  padding: 0 !important;
}
.dialog .one button {
  padding: 11px 77px !important;
}
.dialog .two button {
  padding: 8px 25px !important;
}
.dialog .el-dialog__footer {
  margin-bottom: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialog.vue